module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_01.552e70f9.jpg";